import { render, staticRenderFns } from "./EventPublic.vue?vue&type=template&id=03d58cae"
import script from "./EventPublic.vue?vue&type=script&lang=js"
export * from "./EventPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d58cae')) {
      api.createRecord('03d58cae', component.options)
    } else {
      api.reload('03d58cae', component.options)
    }
    module.hot.accept("./EventPublic.vue?vue&type=template&id=03d58cae", function () {
      api.rerender('03d58cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/EventPublic.vue"
export default component.exports